import { useCallback, useEffect } from 'react';

export const useStickySidebar = (
  footer: HTMLDivElement | null,
  aside: HTMLDivElement | null,
  disabled = false
) => {
  const toggleStickySidebar = useCallback(() => {
    if (disabled) {
      return;
    }

    if (!footer || !aside) {
      return;
    }

    const undoStickyClass = 'undo-sticky';
    const sidebarTopClass = 'sidebar-top-class';
    const hasUndoStickyClass = aside.classList.contains(undoStickyClass);
    const hasSidebarTopClass = aside.classList.contains(sidebarTopClass);
    const footerHeight = footer.getBoundingClientRect().top;

    if (footerHeight && window.innerHeight > footerHeight) {
      !hasUndoStickyClass && aside.classList.add(undoStickyClass);
      hasSidebarTopClass && aside.classList.remove(sidebarTopClass);
    } else {
      hasUndoStickyClass && aside.classList.remove(undoStickyClass);
      !hasSidebarTopClass && aside.classList.add(sidebarTopClass);
    }
  }, [footer, aside, disabled]);

  useEffect(() => {
    toggleStickySidebar();

    window.addEventListener('scroll', toggleStickySidebar);

    return () => {
      window.removeEventListener('scroll', toggleStickySidebar);
    };
  }, [toggleStickySidebar]);
};
